export default __webpack_public_path__ + "static/media/phylactere.aeef3af5.png";